import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../request/request';

export const editLicenseAction = createAsyncThunk('editLicense', async (object, { rejectWithValue }) => {
  const response = await request('/api/v1/tenants/license-update', { method: 'PUT', body: object , auth: true});

  if (response?.data) {
    return response;
  }
  const { error } = response;
  throw rejectWithValue(error || 'Something went wrong');
});